import { BasePicturesModel } from '@/models/BasePicturesModel'

export class Children extends BasePicturesModel {
	static fields () {
		return {
			id: null,
			price: null,
			nearestChildren: {
				id: null
			},
			category: {
				id: null,
				name: null
			}
		}
	}
}
export function createSubpart (data) {
	return Object.freeze(new Children(data))
}
